import React from 'react';
import styles from './OtherRecords.module.css';
import accents from '../moduleCard/accents.module.css';

/**
 * Atalhos para os módulos fora do tipo de atendimento que só têm registros de
 * consultas anteriores: o histórico continua a um clique, sem ocupar a tela.
 * O clique abre o card do módulo nesta consulta (sem alterar o tipo).
 *
 * `items`: [{ key, label, icon, accent, count }].
 */
const OtherRecords = ({ items, onOpen }) => {
  if (!items || items.length === 0) return null;

  return (
    <section className={styles.box} aria-label="Outros registros deste paciente">
      <div className={styles.header}>
        <span className={styles.title}>Outros registros deste paciente</span>
        <span className={styles.hint}>De consultas anteriores, em módulos fora deste tipo de atendimento.</span>
      </div>
      <div className={styles.list}>
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`${styles.item} ${accents[item.accent] || accents.blue}`}
            onClick={() => onOpen(item.key)}
          >
            <span className={styles.icon}>{item.icon}</span>
            <span className={styles.label}>{item.label}</span>
            <span className={styles.count}>{item.count === 1 ? '1 registro' : `${item.count} registros`}</span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default OtherRecords;
